export default {
  state: {
    vaConnectedBanking: false,
    showVaChilds: false,
    mutateBalanceKey: false
  },
  mutations: {
    SET_VA_CONNECTED_BANKING: (state, payload) => {
      state.vaConnectedBanking = payload
    },
    SET_VA_CHILDS: (state, payload) => {
      state.showVaChilds = payload
    },
    CHANGE_VA_BALANCE: (state) => {
      state.mutateBalanceKey = !state.mutateBalanceKey
    }
  },
  getters: {
    getterVaConnectedBanking: state => state.vaConnectedBanking,
    hasVaChilds: state => state.showVaChilds,
    isVaBalanceChanged: state => state.mutateBalanceKey
  }
}
